import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { CONTACT_US_REQUEST } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, POST, DELETE, PUT } = HTTP_METHODS;
const { GET_CONTACT_US, POST_CONTACT_US, DELETE_CONTACT_US, PUT_CONTACT_US, GET_VISITOR_HOSTS } =
  CONTACT_US_REQUEST;

export const contactUsApi = createApi({
  reducerPath: 'contactUsApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  tagTypes: ['ContactUs'],

  endpoints: (builder) => ({
    getContactUs: builder.query({
      query: (data) => ({ url: `${GET_CONTACT_US}${buildQueryString(data)}`, method: GET }),
      providesTags: ['ContactUs']
    }),
    // Public submission from the QR-code Guest Check-In form (no auth required).
    addContactUs: builder.mutation({
      query: (data) => ({ url: POST_CONTACT_US, method: POST, data }),
      invalidatesTags: ['ContactUs']
    }),
    // Public: host lookup for the "who are you here to meet?" dropdown.
    getVisitorHosts: builder.query({
      query: (data) => ({ url: `${GET_VISITOR_HOSTS}${buildQueryString(data)}`, method: GET })
    }),
    editContactUs: builder.mutation({
      query: (data) => ({
        url: `${PUT_CONTACT_US}/${data?.id}`,
        method: PUT,
        data: data.data
      }),
      invalidatesTags: ['ContactUs']
    }),
    deleteContactUs: builder.mutation({
      query: (id) => ({
        url: `${DELETE_CONTACT_US}/${id}`,
        method: DELETE
      }),
      invalidatesTags: ['ContactUs']
    })
  })
});

export const {
  useGetContactUsQuery,
  useAddContactUsMutation,
  useGetVisitorHostsQuery,
  useLazyGetVisitorHostsQuery,
  useEditContactUsMutation,
  useDeleteContactUsMutation
} = contactUsApi;
